export default __webpack_public_path__ + "static/media/Add_User_Module.7052622a.svg";